import './EmailTemplateMetadataTab.scss';
import { capitalize } from '@sonar-software/sonar-ts-lib';
import { CodeHighlight } from '@ui/general';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { usePeriscopeMetadata } from '@hooks';
import { MetadataContainer } from '@periscopes/general/metadata';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';
export const EmailTemplateMetadataTab = ({ index, sonarObjectId }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { loading, metadata } = usePeriscopeMetadata(sonarObjectId, SonarObjectType.SalesforceEmailTemplate);
    const metadataEntries = useMemo(() => {
        if (!metadata) {
            return [];
        }
        const entries = [
            {
                label: COPY_SPECIFIC.TEMPLATE_TYPE,
                type: 'string',
                value: capitalize(metadata.templateType)
            },
            {
                label: COPY_SPECIFIC.AVAILABLE_FOR_USE,
                type: 'boolean',
                value: metadata.availableForUse
            },
            {
                label: COPY_SPECIFIC.FOLDER,
                type: 'string',
                value: metadata.folder
            }
        ];
        return entries;
    }, [metadata]);
    if (loading) {
        return React.createElement(LoadingSpinner, null);
    }
    const subjectCode = (_b = (_a = metadata === null || metadata === void 0 ? void 0 : metadata.subject) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : '';
    const subjectRefs = (_d = (_c = metadata === null || metadata === void 0 ? void 0 : metadata.subject) === null || _c === void 0 ? void 0 : _c.codeReferences) !== null && _d !== void 0 ? _d : [];
    const bodyCode = (_f = (_e = metadata === null || metadata === void 0 ? void 0 : metadata.body) === null || _e === void 0 ? void 0 : _e.code) !== null && _f !== void 0 ? _f : '';
    const bodyRefs = (_h = (_g = metadata === null || metadata === void 0 ? void 0 : metadata.body) === null || _g === void 0 ? void 0 : _g.codeReferences) !== null && _h !== void 0 ? _h : [];
    return (React.createElement("div", { className: 'email-template-metadata' },
        React.createElement(MetadataContainer, { entries: metadataEntries, title: COPY_SPECIFIC.EMAIL_TEMPLATE_INFORMATION }),
        React.createElement("b", null, COPY_SPECIFIC.SUBJECT),
        React.createElement(CodeHighlight, { code: subjectCode, codeReferences: subjectRefs, index: index }),
        React.createElement("b", null, COPY_SPECIFIC.BODY_PLAIN_TEXT_PREVIEW),
        React.createElement(CodeHighlight, { code: bodyCode, codeReferences: bodyRefs, index: index })));
};
